import { TextInputProps } from 'imaginarity-react-ui';
import * as React from 'react';
import { ColorResult, CompactPicker } from 'react-color';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';

export interface EditColorProps<T> extends TextInputProps {
    getter: (value: T) => string | undefined;
}

const EditColor = <T extends BaseEditItem = BaseEditItem>(props: EditColorProps<T>) => {
    const { getter } = props;
    const { value, setValue } = useGPEState(getter);
    const onColorChanged = React.useMemo(() => (color: ColorResult) => {
        setValue(color.hex);
    }, [setValue]);
    return (
        <CompactPicker
            color={value}
            onChangeComplete={onColorChanged}
        />
    );
}
export default EditColor;